<template>
  <!-- 选中位置对话  -->
  <el-drawer :visible.sync="visible" :with-header="false" direction="rtl" size="500px">
    <!-- :with-header="false" -->
    <div class="h-select-location-dialog">
      <div class="title">
        更新绑定位置
      </div>
      <div class="h-select-location-dialog__tree-view">
        <el-tree class="h-select-location-dialog__tree-view__tree" :data="locationList" show-checkbox node-key="id" ref="locationTreeRef" :props="locationProps" check-on-click-node :expand-on-click-node="false" @check="checkLocationChange" check-strictly :default-checked-keys="defaultCheckedKeys" :default-expanded-keys="defaultExpandedKeys"></el-tree>
      </div>
      <div class="h-select-location-dialog__handles">
        <el-button class="h-select-location-dialog__handles__btn" type="primary" plain @click="visible=false">
          取消
        </el-button>
        <el-button class="h-select-location-dialog__handles__btn" type="primary" style="background-color: #084FF7;" @click="submit">
          提交
        </el-button>

      </div>
    </div>
  </el-drawer>
</template>
<script>
let _this
export default {
  data() {
    return {
      visible: false,
      locationList: [],
      locationList_original: [],
      locationProps: { label: 'locationName', children: 'subLocationList', value: 'id' }, // 树结构对应key配置
      defaultCheckedKeys: [], //选中组织已绑定位置
      defaultExpandedKeys: [], //默认展开节点
      checkLocation: [], //选中地址id
    }
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false
    // }
    // value: {
    //   type: String,
    //   default: '选择用户'
    // },
    page: {
      type: String,
      default: 'takeout',
    },
  },
  created() {
    _this = this
    this.getLocationList()
  },
  mounted() {},
  watch: {
    visible(val) {
      if (val) {
        console.log('打开', this.defaultCheckedKeys)
        this.defaultExpandedKeys.splice(0, this.defaultExpandedKeys.length)
        this.initDefaultExpandedKeys(this.locationList)
        this.checkLocation = JSON.parse(JSON.stringify(this.defaultCheckedKeys))
        this.$nextTick(() => {
          this.$refs.locationTreeRef.setCheckedKeys(this.checkLocation)
        })
        this.changeLocationListDisabled()
      }
    },
  },
  computed: {},
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    // 获取位置列表
    getLocationList() {
      let locationUrl = ''
      if (this.page == 'equipment') {
        locationUrl = 'eqGetUserlocationtree'
      } else {
        locationUrl = 'getLocationByCurUser'
      }
      let data = {}
      this.$API[locationUrl](data).then(
        (res) => {
          let l = res
          let initResData = (list) => {
            for (let item of list) {
              item.disabled = false
              if (item.subLocationList && item.subLocationList.length > 0 && item.locationType != 'CAMPUS') {
                initResData(item.subLocationList)
              }
              if (item.locationType == 'CAMPUS') {
                item.subLocationList = null
              }
            }
          }
          initResData(l)
          this.locationList = l
          this.locationList_original = l
          // this.initLocationListDisabled()
        },
        (err) => {
          console.log('getLocationerr', err)
        }
      )
    },
    // 初始化默认展开
    initDefaultExpandedKeys(data, i) {
      var i = i || 0
      //默认打开两级，显示第三级
      if (i > 2) {
        return
      }
      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.defaultExpandedKeys.push(item.id)

          if (item.subLocationList && item.subLocationList.length > 0) {
            this.initDefaultExpandedKeys(item.subLocationList, i + 1)
          }
        })
      } else {
        this.defaultExpandedKeys.push(data.id)

        if (data.subLocationList && data.subLocationList.length > 0) {
          this.initDefaultExpandedKeys(data.subLocationList, i + 1)
        }
      }
    },
    // 更新默认选中位置
    updateDefaultCheckedKeys(data) {
      console.log('更新默认选中位置', data)
      this.defaultCheckedKeys = JSON.parse(JSON.stringify(data))
    },
    // 选中位置变化触发
    checkLocationChange(node, checkedNodes) {
      console.log('选中位置变化触发node', node)
      console.log('选中位置变化触发checknodes', checkedNodes)
      // console.log('选中位置变化触发1111', this.checkLocation);
      let checkedKeys = checkedNodes.checkedKeys
      let init = (list) => {
        for (let item of list) {
          if (_this.checkLocation.indexOf(item.id) > -1) {
            _this.checkLocation.splice(_this.checkLocation.indexOf(item.id), 1)
          }
          if (item.subLocationList && item.subLocationList.length > 0) {
            init(item.subLocationList)
          }
        }
      }
      // let v = -1
      // let v2 = -1

      // v = this.checkLocation.indexOf(node.id)
      // v2 = checkedKeys.indexOf(node.id)
      if (checkedKeys.indexOf(node.id) > -1) {
        this.checkLocation.push(node.id)
        if (node.subLocationList && node.subLocationList.length > 0) {
          init(node.subLocationList)
        }
      } else {
        this.checkLocation.splice(this.checkLocation.indexOf(node.id), 1)
      }
      this.$nextTick(() => {
        this.$refs.locationTreeRef.setCheckedKeys(this.checkLocation)
      })
      this.changeLocationListDisabled()
    },
    // 初始化失效状态
    initLocationListDisabled(list) {
      console.log('初始化失效状态')
      for (let item of list) {
        item.disabled = false
        // console.log('>>>>>>>>>>>>>>>>>>>', item.locationType);
        if (item.subLocationList && item.subLocationList.length > 0 && item.locationType != 'CAMPUS') {
          this.initLocationListDisabled(item.subLocationList)
        }
        if (item.locationType == 'CAMPUS') {
          item.subLocationList = null
        }
      }
    },
    // 改变位置禁用状态
    changeLocationListDisabled() {
      console.log('---------------改变位置禁用状态')
      this.initLocationListDisabled(this.locationList)
      let checkedVerify = (list) => {
        for (let item of list) {
          if (_this.checkLocation.indexOf(item.id) > -1) {
            if (item.subLocationList && item.subLocationList.length > 0) {
              setDisabled(item.subLocationList)
            }
          } else {
            if (item.subLocationList && item.subLocationList.length > 0) {
              checkedVerify(item.subLocationList)
            }
          }
        }
      }

      let setDisabled = (list) => {
        if (list.subLocationList && list.subLocationList.length > 0) {
          checkedVerify(list.subLocationList)
        }
        console.log('0000000000000setDisabled', list)
        for (let item of list) {
          item.disabled = true
          if (item.subLocationList && item.subLocationList.length > 0) {
            setDisabled(item.subLocationList)
          }
          // for (let i in _this.checkLocation) {
          //   if (_this.checkLocation[i] == item.id) {
          //     _this.checkLocation.splice(i, 1)
          //   }
          // }
        }
      }
      checkedVerify(_this.locationList)
    },
    // 提交
    submit() {
      if (JSON.stringify(this.checkLocation) == JSON.stringify(this.defaultCheckedKeys)) {
        this.$message({
          message: '数据无修改',
          duration: 1000,
          type: 'warning',
        })
        return
      }
      this.$emit('change', this.checkLocation)
    },
  },
}
</script>
<style scoped lang="stylus">
.h-select-location-dialog
  display flex
  flex-direction column
  height 100vh
  width 100%
  padding 20px
  .title
    height 60px
    line-height 60px
    font-size 20px
    font-weight 400
    // margin-bottom 30px
    color #3b5eff
    user-select none
  .title:before
    content '|'
    font-size 16px
    background #3b5eff
    margin-right 20px
  &__tree-view
    // background #F5F6FA
    overflow auto
    // overflow-x auto
    // height calc(100% - 200px)
    width 100%
    flex 1
    clear both
    // display flex
    // white-space nowrap
    &__tree
      // background #F5F6FA
      height 100%
      width 100%
  &__handles
    height 100px
    width 100%
    display flex
    flex-direction row
    align-items center
    justify-content center
    &__btn
      width 150px
    .h-select-location-dialog__handles__btn+.h-select-location-dialog__handles__btn
      margin-left 20px
>>> .el-drawer:focus
  outline 0
</style>



// WEBPACK FOOTER //
// src/components/parts/hSelectLocationDialog.vue